import React, { useEffect, useState } from 'react';
import style from "./CentralWallet.module.css";
import { AuthConsole } from '../../Utils/helper';
import { useParams } from 'react-router-dom';
import API from "../../ApiConfig";
import { BASE_URL, CENTRAL_WALLET_VERIFY_RECHARGE, CENTRAL_WALLET_VERIFY_TOKEN } from '../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';

const CentralWallet = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);


  const [isSuccess, setIsSuccess]=useState(false);



  const [isFailed, setIsFailed]=useState(false)

  const [isCancelled, setIsCancelled]=useState(false)
  useEffect(() => {
    setTimeout(() => setDisableBtn(false), 10000);
    verifyToken();
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => reject(false);
      document.body.appendChild(script);
    });
  };

  const verifyToken = async () => {
    setLoading(true);
    try {
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        cogoToast.error("Razorpay SDK failed to load");
        setLoading(false);
        return;
      }

      const res = await API.post(CENTRAL_WALLET_VERIFY_TOKEN, { token });
      const order = res.data.data;

      if (!order) throw new Error("Failed to create order");

      const options = {
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        name: "AuthNumber",
        description: order.description,
        order_id: order.razorpay_order_id,
        prefill: {
          name: order.user_details?.client_name,
          email: order.user_details?.email,
          contact: order.user_details?.phone_number,
        },
        theme: { color: "#3399cc" },
        handler: async (response) => {
          setLoading(true);
          try {
            const verifyRes = await fetch(`${BASE_URL}${CENTRAL_WALLET_VERIFY_RECHARGE}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                order_id: response.razorpay_order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                token,
              }),
            });
            const result = await verifyRes.json();
            console.log(result);
            
            if (result.status_code==1){setLoading(false); setIsSuccess(true); cogoToast.success("Payment Verified!")}
            else {setLoading(false);setIsFailed(true);cogoToast.error("Payment verification failed")}
          } catch (err) {
            console.error(err);
            cogoToast.error("Verification error");
          } finally {
            setLoading(false);
          }
        },
        modal: {
          ondismiss: () => {
            setLoading(false);
            setIsCancelled(true)
            cogoToast.warn("Payment cancelled");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
        setIsFailed(true)
      cogoToast.error(err.response.data.message || "Payment initialization failed");
      setLoading(false);
    }
  };

  return (
    <div className={style.walletContainer}>
      <div className={style.page}>
        <div className={style.card} role="main" aria-live="polite">
    {(isSuccess || isFailed) &&    <img
        className={style.checkCircleIcon}
        alt=""
        src={isSuccess?"/checkcircle.svg":"/cancel.svg"}
        />}
        {loading?  <h1>Redirecting to secure payment…</h1>:
        isSuccess?
        <h1>Success...</h1>: isFailed ?<h1>Payment Failed</h1>:isCancelled?<h1>🚫Payment Cancelled...</h1>:""}
          <p className={style.lead}>{loading? "Please wait — we are opening the payment window.":isSuccess?"You can now Close this window":isFailed?"Please try Again":isCancelled?"Try Refreshing the page":""}</p>

          {loading && (
            <div className={style.amountCard} aria-hidden="false">
              <div className={style.spinner} aria-hidden="true"></div>
            </div>
          )}

          <div className={style.fallback}>
            <div className={style.mutedHint}>If nothing happens, make sure popups are allowed for this site.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CentralWallet;
